import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Element.Dialog.props.lockScroll.default = false;
Vue.use(Element)
